<ui-modal-full title="Task details" (backClicked)="back()" (closeClicked)="close()">
  @if (loadingTask()) {
    <ui-loading-spinner />
  } @else {
    @switch (mode()) {
      @case ('overview') {
        <section>
          @if (showTopUpBalanceAlert()) {
            <div class="mb-6">
              <ui-alert
                color="error"
                [icon]="'griddy-info-circle'"
                [title]="'Not enough to cover your next clean'"
                [isMobile]="isMobile$ | async"
                [message]="
                  'Please top up your balance later in Settings → Marketplace → Add funds to ensure upcoming cleans are covered.'
                "
                [action]="{ label: 'Top up balance' }"
                [hideCloseButton]="true" />
            </div>
          }

          <div class="flex items-center gap-3 mb-3">
            <!-- We dont use the task name here as its terrible, and for now we're only handling cleaning. This will likely need changing in future-->
            <h2 class="mb-0">Cleaning check-in task</h2>
            @if (progressStatusLabel()) {
              <ui-badge [value]="progressStatusLabel()" appearance="subtle" />
            }
          </div>

          <div class="text-text-tertiary mb-6">{{ summaryText() }}</div>

          @if (task().progress_status) {
            <div class="flex flex-col w-full gap-5 mb-6 md:h-[220px] md:flex-row md:items-center">
              <!-- Status -->
              <sbnb-task-progress-tracker class="h-44 md:h-full md:flex-1" [progressStatus]="task().progress_status" />

              <!-- Map -->
              @if (task().progress_location?.latitude && task().progress_location?.longitude) {
                <sbnb-task-location-map class="h-44 md:h-full md:flex-1" [location]="task().progress_location" />
              }
            </div>
          }

          <div class="mb-6">
            <strong>Starting at</strong>
            <!-- Start -->
            <div class="flex items-center gap-2">
              <mat-form-field class="flex-1 nopadding">
                <input matInput disabled type="text" readonly [value]="task().start_date | date: 'mediumDate'" />
                <ui-icon matSuffix icon="griddy-calendar" />
              </mat-form-field>

              <mat-form-field class="flex-1 nopadding">
                <input
                  matInput
                  disabled
                  type="text"
                  readonly
                  [value]="startHour() + ':' + (startMin() === 0 ? '00' : startMin())" />
                <ui-icon matSuffix icon="time" />
              </mat-form-field>

              <!-- <mat-menu #dateMenu="matMenu">
                <ui-date-picker
                  [startDate]="task().start_date"
                  [numMonths]="1"
                  [checkInOutStyling]="false"
                  (click)="$event.stopPropagation()"
                  (datesSelected)="updateTaskStartDate($event); dateMenuTrigger.closeMenu()" />
              </mat-menu>

              <mat-menu #timeMenu="matMenu">
                <sbnb-time-picker
                  class="flex-1"
                  [inlineMode]="true"
                  [hours]="startHour()"
                  [minutes]="startMin()"
                  (timeUpdated)="startUpdated($event)" />
              </mat-menu> -->
            </div>
          </div>

          <div class="mb-6">
            <strong>Ending at</strong>
            <!-- Start -->
            <div class="flex items-center gap-2">
              <mat-form-field class="flex-1 nopadding">
                <input matInput disabled type="text" readonly [value]="task().end_date | date: 'mediumDate'" />
                <ui-icon matSuffix icon="griddy-calendar" />
              </mat-form-field>

              <mat-form-field class="flex-1 nopadding">
                <input
                  matInput
                  disabled
                  type="text"
                  readonly
                  [value]="endHour() + ':' + (endMin() === 0 ? '00' : endMin())" />
                <ui-icon matSuffix icon="time" />
              </mat-form-field>

              <!-- <mat-menu #endDateMenu="matMenu">
                <ui-date-picker
                  [startDate]="task().end_date"
                  [numMonths]="1"
                  [checkInOutStyling]="false"
                  (click)="$event.stopPropagation()"
                  (datesSelected)="updateTaskEndDate($event); dateMenuTrigger.closeMenu()" />
              </mat-menu>

              <mat-menu #endTimeMenu="matMenu">
                <sbnb-time-picker
                  class="flex-1"
                  [inlineMode]="true"
                  [hours]="endHour()"
                  [minutes]="endMin()"
                  (timeUpdated)="endUpdated($event)" />
              </mat-menu> -->
            </div>
          </div>

          <!-- Assigned to -->
          @if (task()?.marketplace_teammate) {
            <div class="mb-6 flex flex-col gap-2">
              <strong>Assigned to</strong>

              <sbnb-cleaner-card
                [cleaner]="task()!.marketplace_teammate"
                [showMessageButton]="true"
                [hasMessages]="!!task()?.operations_chat"
                [unreadMessagesCount]="task()?.operations_chat?.operations_thread_new_messages_count || 0"
                (messageClick)="openMessages()" />
            </div>
          } @else {
            <!-- No cleaner assigned to this task -->
            <div class="mb-6 flex flex-col gap-2">
              <strong>No cleaner assigned to this task</strong>
            </div>
          }

          <!-- Checklist -->
          @if (task().checklist) {
            <div class="mb-6 flex flex-col gap-2">
              <div class="flex item-center gap-2">
                <strong class="flex-1">Checklist</strong>
                <ui-badge
                  [value]="checklistNumberOfCompletedItems() + ' of ' + checklistNumberOfItems() + ' tasks completed'"
                  appearance="subtle"
                  variant="gray" />
              </div>
              <ui-card [description]="checklistSummary()" (click)="openChecklist()" />
            </div>
          }

          <!-- Problems -->
          @if (problemSummary()) {
            <div class="mb-6 flex flex-col gap-2">
              <strong>Problems noted by your cleaner</strong>
              <ui-card [description]="problemSummary()" (click)="openProblems()" />
            </div>
          }

          <!-- Property access -->
          @if (propertyAccessSummary()) {
            <div class="mb-6 flex flex-col gap-2">
              <strong>Property access</strong>
              <ui-card [description]="propertyAccessSummary()" (click)="setMode('access')" />
            </div>
          }

          <!-- Cleanster booking id -->
          @if (task().cleanster_booking_id) {
            <div class="mb-6 flex flex-col gap-2">
              <strong>Cleanster booking ID</strong>
              <div class="text-text-tertiary mb-6">{{ task().cleanster_booking_id }}</div>
            </div>
          }
        </section>
      }

      @case ('checklist-viewer') {
        <section>
          <div class="flex item-center gap-4 mb-8">
            <h2 class="mb-0">Checklist</h2>
            <ui-badge
              [value]="checklistNumberOfCompletedItems() + ' of ' + checklistNumberOfItems() + ' tasks completed'"
              appearance="subtle"
              variant="gray" />
          </div>
          @if (task()?.checklist) {
            <sbnb-task-checklist-viewer [checklist]="task()!.checklist" />
          } @else {
            <div class="text-text-secondary">No checklist available for this task.</div>
          }
        </section>
      }

      @case ('problems') {
        <section>
          <div class="flex flex-wrap items-center gap-4 mb-8">
            <h2 class="mb-0 flex-shrink-0">Problems noted by your cleaner</h2>
            <ui-badge [value]="problemNumberOfItems() + ' problems reported'" appearance="subtle" variant="gray" />
          </div>
          @if (task()?.problems) {
            <sbnb-task-problems-viewer [problems]="task()!.problems" />
          } @else {
            <div class="text-text-secondary">No problems reported for this task.</div>
          }
        </section>
      }

      @case ('access') {
        <section>
          <h2>How should the cleaner access this property?</h2>

          <mat-radio-group class="grid gap-4 mb-6" [(ngModel)]="task().create_operation_codes">
            <div
              class="grid border rounded-lg"
              [class.cursor-pointer]="smartLockState().canUseSmartLock && !smartLockState().isLoading"
              [class.cursor-not-allowed]="!smartLockState().canUseSmartLock && !smartLockState().isLoading">
              <mat-radio-button
                class="!p-5"
                [value]="true"
                [disabled]="!smartLockState().canUseSmartLock || smartLockState().isLoading">
                <div class="flex flex-col gap-1 pl-2">
                  <div class="flex items-center gap-2">
                    <strong>Smart lock</strong>
                    @if (smartLockState().isLoading) {
                      <ui-loading-spinner [size]="16" />
                    } @else if (!smartLockState().canUseSmartLock) {
                      <ui-icon
                        icon="griddy-info-circle"
                        class="text-smoke-darker"
                        [size]="16"
                        matTooltip="A connected smart lock is required to use this feature.">
                      </ui-icon>
                    }
                  </div>
                  @if (smartLockState().canUseSmartLock || smartLockState().isLoading) {
                    <span class="leading-relaxed text-text-tertiary">
                      Automatically generate a smart lock code for the cleaner to access the property that can only be
                      used when they arrive.
                    </span>
                  } @else {
                    <span class="leading-relaxed text-[rgba(0,0,0,.38)]">
                      Add a smart lock to this property to set this up.
                    </span>
                  }
                </div>
              </mat-radio-button>
            </div>

            <div class="grid border rounded-lg cursor-pointer">
              <mat-radio-button class="!p-5" [value]="false">
                <strong class="pl-2">Other access</strong>
              </mat-radio-button>
            </div>
          </mat-radio-group>

          <strong class="block mb-2">Additional instructions</strong>
          <sbnb-textarea
            [ngModel]="task().note"
            (ngModelChange)="updateTaskNote($event)"
            [placeholder]="'Enter your message...'"
            [minRows]="1"
            [maxRows]="8"></sbnb-textarea>
        </section>
      }

      @case ('checklist-editor') {
        <section>
          <!-- AI suggestions alert -->
          @if (task()?.ai_suggestions?.todos?.length) {
            <ui-alert
              [type]="'inline'"
              [color]="'secondary'"
              [icon]="'griddy-magic-wand'"
              [title]="'Cleaning tasks suggested'"
              [message]="getCleaningSuggestionMessage()"
              [hideCloseButton]="true"
              [action]="{
                label: 'Add items',
                onClick: addSuggestedTasksToChecklist
              }"
              (onClose)="dismissCleaningSuggestions()"
              class="mb-6" />
          }

          <h2>Checklist</h2>

          @if (!task().checklist || task().checklist?.groups?.length === 0) {
            <div class="rounded-[20px] border border-border-secondary p-4 flex items-center gap-2">
              <ui-icon icon="griddy-info-circle" />
              <span>You haven't created a checklist for this task rule yet.</span>
            </div>
          }
          <ui-checklist-builder [(checklist)]="task().checklist" />
        </section>
      }
    }
  }

  <!-- Custom footer actions - this will be projected into the footer of the modal-->
  <div footerActions class="flex gap-3 items-center">
    <ui-button label="Remove task" variant="link-destructive" (onClick)="removeTaskPrompt()" />

    <div class="flex-1"></div>

    @if (mode() === 'overview') {
      <ui-button label="Cancel" size="lg" variant="tertiary" (onClick)="close()" />
    }

    <ui-button
      label="Apply changes"
      size="lg"
      variant="primary"
      (onClick)="save()"
      [loading]="saving()"
      loadingLabel="Saving..." />
  </div>
</ui-modal-full>
